import React from 'react'
import NameRecordingContent from './Ui/Blocks/NameRecordingContent'

const NameRecording = () => {
  return <NameRecordingContent />
}

export default NameRecording
